<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import pdf from 'vue-pdf'

/**
 * Advanced table component
 */
export default {
  name: "ArmadaDetail",
  page: {
    title: "Lihat Armada",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, pdf },
  data() {
    return {
      title: "Lihat Armada",
      items: [
        {
          text: "Manajemen Armada",
        },
        {
          text: "Armada",
          href: "/truck"
        },
        {
          text: "Lihat",
          active: true
        },
      ],
      form: {},
      photos: [],
      isSubmitArmadaError: false,
      errorMessage: null,
      isSubmitArmadaSuccess: false,
      successMessage: null,
      document: {
        type: "",
        src: ""
      },
    };
  },
  computed: {
    photoDepan() {
      const depan = this.photos.find(item => item.position === 'depan')
      if (depan !== undefined) {
        return depan.path
      } else {
        return null
      }
    },
    photoBelakang() {
      const belakang = this.photos.find(item => item.position === 'belakang')
      if (belakang !== undefined) {
        return belakang.path
      } else {
        return null
      }
    },
    photoKiri() {
      const kiri = this.photos.find(item => item.position === 'kiri')
      if (kiri !== undefined) {
        return kiri.path
      } else {
        return null
      }
    },
    photoKanan() {
      const kanan = this.photos.find(item => item.position === 'kanan')
      if (kanan !== undefined) {
        return kanan.path
      } else {
        return null
      }
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.$axios.get(`/v1/logistic_company/armada/${this.$route.params.id}`)
        .then(response => {
          this.form = response.data.data
          this.photos = response.data.data.photos
        })
        .catch(error => {
          if (error.response.status == 404) {
            this.$router.push('/404')
          }
        })
    },
    confirmDelete() {
      Swal.fire({
        title: "Apa Anda yakin akan menghapus data ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then( async (result) => {
        if (result.value) {
          await this.$axios.delete(`/v1/logistic_company/armada/${this.$route.params.id}`)
          .then(response => {
            this.isSubmitArmadaSuccess = true
            this.isSubmitArmadaError = false
            this.successMessage = response.data.message
            setTimeout(() => {
              this.$router.push('/truck')
            }, 3000)
          }).catch(error => {
            this.isSubmitArmadaSuccess = false
            this.isSubmitArmadaError = true
            this.errorMessage = error.response.data.message
          })
        }
      });
    },
    activate() {
      Swal.fire({
        title: "Apa Anda yakin akan mengaktifkan armada ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then( async (result) => {
        if (result.value) {
          await this.$axios.put(`/v1/logistic_company/armada/${this.$route.params.id}/status`, {
            status: 'aktif'
          })
          .then(response => {
            this.isSubmitArmadaSuccess = true
            this.isSubmitArmadaError = false
            this.successMessage = response.data.message
            this.getDetail()
          }).catch(error => {
            this.isSubmitArmadaSuccess = false
            this.isSubmitArmadaError = true
            this.errorMessage = error.response.data.message
          })
        }
      });
    },
    disactivate() {
      Swal.fire({
        title: "Apa Anda yakin akan menonaktifkan armada ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then( async (result) => {
        if (result.value) {
          await this.$axios.put(`/v1/logistic_company/armada/${this.$route.params.id}/status`, {
            status: 'tidak aktif'
          })
          .then(response => {
            this.isSubmitArmadaSuccess = true
            this.isSubmitArmadaError = false
            this.successMessage = response.data.message
            this.getDetail()
          }).catch(error => {
            this.isSubmitArmadaSuccess = false
            this.isSubmitArmadaError = true
            this.errorMessage = error.response.data.message
          })
        }
      });
    },
    previewDoc(doc) {
      const extention = doc.split(".").pop()
      this.document = {
        type: extention,
        src: doc
      }
      this.$refs.modalDocument.show()
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <b-form @submit.prevent="submitDriver" class="form-horizontal">
          <div class="card">
            <div class="card-body">
              <b-alert
                v-model="isSubmitArmadaSuccess"
                class="mt-3"
                variant="success"
                dismissible
              >{{ successMessage }}</b-alert>

              <b-alert
                v-model="isSubmitArmadaError"
                class="mt-3"
                variant="danger"
                dismissible
              >{{errorMessage}}</b-alert>

              <div class="row">
                <div class="col-lg-4">
                  <h5 class="font-weight-semibold">STNK</h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-light">No STNK</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.stnk_number || '-' }}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Merk</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.merk || '-' }}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Model</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.model || '-' }}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Warna</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.color || '-' }}
                      </p>
                      <br />
                    </div>
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-light">No Plat</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.plat_number || '-' }}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Tipe</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.vehicle_category ? form.vehicle_category.name : '-' }}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Masa Aktif</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.stnk_expired_at || '-' | date_only }}
                      </p>
                      <br />
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 border-kiri">
                  <h5 class="font-weight-semibold">KIR</h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-light">KIR</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.kir_number || '-' }}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Volume</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.volume ? `${form.volume}  Ton` : '-' }}
                      </p>
                      <br />
                    </div>
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-light">Masa Aktif</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.kir_expired_at || '-' | date_only}}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Tonase</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.tonase ? `${form.tonase}  Ton` : '-' }}
                      </p>
                      <br />
                    </div>
                    <div class="col-lg-4">
                      <label class="mb-0 form-label font-weight-light">Panjang</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.length ? `${form.length}  m` : '-' }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <label class="mb-0 form-label font-weight-light">Lebar</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.width ? `${form.width}  m` : '-' }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <label class="mb-0 form-label font-weight-light">Tinggi</label>
                      <p class="font-weight-bolder mb-0">
                        {{ form.height ? `${form.height}  m` : '-' }}
                      </p>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-4 border-kiri pl-4">
                  <h5 class="font-weight-semibold">Data Foto</h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <div v-if="!photoDepan" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">
                        Depan
                      </div>
                      <img v-if="photoDepan" :src="photoDepan" class="img-thumbnail w-100 mb-3" />
                    </div>
                    <div class="col-lg-6">
                      <div v-if="!photoBelakang" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">
                        Belakang
                      </div>
                      <img v-if="photoBelakang" :src="photoBelakang" class="img-thumbnail w-100 mb-3" />
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <div v-if="!photoKiri" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">
                        Kiri
                      </div>
                      <img v-if="photoKiri" :src="photoKiri" class="img-thumbnail w-100 mb-3" />
                    </div>
                    <div class="col-lg-6">
                      <div v-if="!photoKanan" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">
                        Kanan
                      </div>
                      <img v-if="photoKanan" :src="photoKanan" class="img-thumbnail w-100 mb-3" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <b-button variant="outline-danger" type="button" class="w-100 mt-1" @click="previewDoc(form.stnk_path)">
                    STNK<br />
                    <u>Lihat</u>
                  </b-button>
                </div>
                <div class="col-lg-4">
                  <b-button variant="outline-danger" type="button" class="w-100 mt-1" @click="previewDoc(form.kir_path)">
                    KIR<br />
                    <u>Lihat</u>
                  </b-button>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-sm-2">
                  <b-button to="/truck" type="button" class="w-100 btn-light">Kembali</b-button>
                </div>
                <div class="col-sm-2">
                  <b-button type="button" class="w-100 btn-light" @click="confirmDelete">Hapus</b-button>
                </div>
                <div class="col-sm-2">
                  <b-button type="button" variant="danger" class="w-100" @click="$router.push(`/truck/${$route.params.id}/edit`)">Edit</b-button>
                </div>
                <div class="col-sm-2" v-if="form.status == 'aktif'">
                  <b-button type="button" variant="outline-danger" class="w-100" @click="disactivate">Non Aktifkan</b-button>
                </div>
                <div class="col-sm-2" v-if="form.status == 'tidak aktif'">
                  <b-button type="button" variant="danger" class="w-100" @click="activate">Aktifkan</b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>

    <!-- modal preview document -->
    <b-modal title="Preview" ref="modalDocument" id="modal-document" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-12 text-center">
          <b-link :href="document.src" target="_blank">
            <pdf v-if="document.type === 'pdf'" :src="document.src"></pdf>
            <b-img v-else fluid :src="document.src"></b-img>
          </b-link>
        </div>
      </div>
    </b-modal>
    <!-- / modal-->
  </Layout>
</template>